<template>
  <div>
    <vx-card class="mb-base">
      <div class="mb-base mt-4 vx-row justify-between items-top">
        <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-start">
          <span class="text-black text-2xl">Riwayat Pemasukan Melalui Login</span>
        </section>
        <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-end">
          <div class="justify-end gap-0 flex-wrap items-end">
            <div class="text-right">
              <p class="mb-2">Total Pendapatan Melalui Login</p>
              <h5>
                <strong class="text-success text-xl">{{
                  pendapatanTotalLogin | toCurrency
                }}</strong>
              </h5>
            </div>
          </div>
        </section>
        <!-- <section
          v-if="profile.level.id !== 2"
          class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-end"
        >
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <feather-icon
                :icon="typeSelect.id === 1 ? 'ArrowUpIcon' : 'ArrowDownIcon'"
                svgClasses="h-6 w-6"
                class="mr-2"
              />
              <span class="mr-2">{{ typeSelect.text }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div> -->
        <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
        <!-- <vs-dropdown-menu>
              <vs-dropdown-item
                v-for="(item, index) in transactionType"
                :key="index"
                @click="typeSelect = item"
              >
                <span>{{ item.text }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </section> -->
      </div>
      <main>
        <vs-tabs v-if="jenisList.length !== 0">
          <vs-tab
            v-for="(item, index) in jenisList.filter(
              (v) => v.name != 'TOP UP' && v.name != 'PPOB'
            )"
            :key="index"
            :label="item.name"
          >
            <div class="tab-text mt-2">
              <tabel-content
                :jenis="item"
                :mitra_id="mitra_id"
                :akumulasiData="
                  akumulasiData.filter((v) => v.jenis_pembayaran.id === item.id)
                "
              ></tabel-content>
            </div>
          </vs-tab>
        </vs-tabs>
        <center v-else class="py-6 w-full">
          <h4>Loading...</h4>
        </center>
      </main>
    </vx-card>
    <vx-card>
      <div class="mb-base mt-4 vx-row justify-between items-top">
        <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-start">
          <span class="text-black text-2xl">Riwayat Pemasukan Non-Login</span>
        </section>
        <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-end">
          <div class="justify-end gap-0 flex-wrap items-end">
            <div class="text-right">
              <p class="mb-2">Total Pendapatan Melalui Non-Login</p>
              <h5>
                <strong class="text-success text-xl">{{
                  pendapatanTotalNonLogin | toCurrency
                }}</strong>
              </h5>
            </div>
          </div>
        </section>
      </div>
      <main>
        <vs-tabs v-if="jenisList.length !== 0">
          <vs-tab
            v-for="(item, index) in jenisList.filter(
              (v) => v.name != 'TOP UP' && v.name != 'PPOB'
            )"
            :key="index"
            :label="item.name"
          >
            <div class="tab-text mt-2">
              <tabel-content-non-login
                :jenis="item"
                :mitra_id="mitra_id"
                :akumulasiData="
                  akumulasiDataNonLogin.filter((v) => v.jenis_pembayaran.id === item.id)
                "
              ></tabel-content-non-login>
            </div>
          </vs-tab>
        </vs-tabs>
        <center v-else class="py-6 w-full">
          <h4>Loading...</h4>
        </center>
      </main>
    </vx-card>
  </div>
</template>

<script>
import TabelContent from "@/views/pendapatan/component/TabelContent.vue";
import TabelContentNonLogin from "@/views/pendapatan/component/TabelContentNonLogin.vue";

const transactionType = [
  {
    id: 1,
    text: "Data Pengeluaran",
  },
  {
    id: 0,
    text: "Data Pemasukan",
  },
];

export default {
  components: {
    TabelContent,
    TabelContentNonLogin,
  },
  props: {
    akumulasiDataNonLogin: { type: Array, default: [] },
    akumulasiData: { type: Array, default: [] },
    mitra_id: { type: Number, default: 0 },
  },
  data() {
    return {
      listDataNonLogin: [],
      listData: [],
      jenisList: [],
      typeSelect: transactionType[1],
      transactionType,
    };
  },
  computed: {
    profile() {
      return this.$store.state.auth.profileAccess.profile;
    },
    pendapatanTotalLogin() {
      let total = 0;
      this.akumulasiData.forEach((v) => {
        total += v.jumlah_bayar;
      });
      return total;
    },
    pendapatanTotalNonLogin() {
      let total = 0;
      this.akumulasiDataNonLogin.forEach((v) => {
        total += v.jumlah_bayar;
      });
      return total;
    },
    acumulateDataNonLogin: {
      get() {
        let count = 0;
        this.listDataNonLogin.forEach((v) => {
          count += v.jumlah_bayar;
        });

        return count;
      },
      set(v) {
        this.listDataNonLogin = v;
      },
    },
    acumulateData: {
      get() {
        let count = 0;
        this.listData.forEach((v) => {
          count += v.jumlah_bayar;
        });

        return count;
      },
      set(v) {
        this.listData = v;
      },
    },
  },
  methods: {
    getJenis() {
      this.$store
        .dispatch("transaksi/getJenisTransaksi", {})
        .then((v) => {
          this.jenisList = v.data;
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
  },
  created() {
    if (this.$store.state.transaksi.jenisList.length !== 0) {
      if (
        this.$store.state.transaksi.jenisList[0].name === "TOP UP" ||
        this.$store.state.transaksi.jenisList[0].name === "PPOB"
      ) {
        this.jenisList = this.$store.state.transaksi.jenisList.reverse();
      } else {
        this.jenisList = this.$store.state.transaksi.jenisList;
      }
    } else {
      this.getJenis();
    }
  },
};
</script>

<style lang="scss" scoped>
.text-success {
  color: green;
}
.text-danger {
  color: red;
}
.text-blue {
  color: blue;
}
img {
  max-height: 92px;
  max-width: 92px;
  overflow: auto;
}
</style>
